export class BrandsFilterListener {
    public static bindSubmit(form: HTMLFormElement, onSubmit: (event: SubmitEvent) => void): void {
        form.addEventListener("submit", onSubmit);
    }

    public static bindMouseDown(element: HTMLElement, onMouseDown: (event: MouseEvent) => void): void {
        element.addEventListener("mousedown", onMouseDown);
    }

    public static bindClick(input: HTMLInputElement, onClick: (event: MouseEvent) => void): void {
        input.addEventListener("click", onClick);
    }

    public static bindChange(input: HTMLInputElement, onChange: (event: Event) => void): void {
        input.addEventListener("change", onChange);
    }
}
